class BonusReleaseRatioViewModel {
  category;
  layer_metric_amount;
  layer_metric_qualify;
  level;
}
class BonusCasinoViewModel {
  aggregators;
  game_codes;
  source_types;
  supplier_codes;
}
class BonusMetaViewModel {
  bonus_value_param;
  casino_excluded;
  casino_included;
  expire_period;
  max_bonus_get;
  metric_amount;
  metric_qualify;
  min_deposit;
  overall_max_bonus_get;
  rake_amount;
  rake_qualify;
  release_ratios;
  show_max_bonus_in_total;
  ticket_serial;
  time_range_by_date;
  total_max_bonus_get;
  unrealized_expire_period;
}
class BonusCodeDetailsViewModel {
  id;
  bonus_id;
  bonus_name;
  bonus_status;
  bonus_to_credit;
  create_time;
  credit_type;
  description;
  end_time;
  last_update;
  marketing_codes;
  meta;
  platform;
  release_mechanism;
  release_metric;
  release_ratio_type;
  start_time;
  threshold;
  total_paid_out_amount;
  created_by;
}
export {
  BonusCasinoViewModel,
  BonusCodeDetailsViewModel,
  BonusMetaViewModel,
  BonusReleaseRatioViewModel
};
//# sourceMappingURL=types.js.map
